import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import { RichTextEditor } from '@/components/common/rich-text-editor/RichTextEditor';
import { Skeleton } from '@/components/ui/skeleton';
import useGetServiceById from '@/hooks/queries/services-api/useGetServiceById';
import usePatchService from '@/hooks/queries/services-api/usePatchService';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const EditServiceLanding = () => {
  const { t } = useTranslation();
  const { id: serviceId } = useParams();
  const { data: service, isError, isLoading } = useGetServiceById(serviceId);

  const { mutate, isPending } = usePatchService({ disabledRedirect: true });

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[80vh]" />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <NoData />
        <ErrorMessage />
      </>
    );
  }

  if (!service) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  return (
    <div className="mb-4">
      <GoBack />
      <RichTextEditor
        initialContent={service.landing_page_content}
        onSave={(content) => {
          mutate({
            payload: { landing_page_content: content },
            serviceId: service.id
          });
        }}
      />
    </div>
  );
};

export default EditServiceLanding;
